import Reveal from "@/components/Reveal";

/**
 * Brand voice strip — Gujarati taglines with English translations.
 * A signature touch reflecting the real Sahyog Finance Gujarati roots.
 */
const QUOTES = [
  {
    gu: "તમારી મહેનત તમારી સૌથી મોટી મૂડી છે",
    en: "Your hard work is your biggest asset.",
  },
  {
    gu: "સહયોગ આપનો… વિકાસ આપનો…",
    en: "Our support · Your growth.",
  },
  {
    gu: "દરેક મોટું સપનું એક નાનકડા નિર્ણયથી શરૂ થાય છે",
    en: "Every big dream begins with one small decision.",
  },
];

export default function BrandVoice() {
  return (
    <section
      id="brand-voice"
      data-testid="brand-voice"
      className="relative banner-gold text-white py-20 md:py-28 overflow-hidden noise-overlay"
    >
      {/* Gold accent stripes */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      <div className="relative max-w-6xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <span className="gold-divider text-[10px] tracking-[0.4em] uppercase">
            Brand promise
          </span>
          <p
            data-testid="brand-tagline-main"
            className="font-script italic text-3xl md:text-5xl mt-6 text-white leading-tight"
          >
            તમારા વિશ્વાસની અમારી સાથે સહયાત્રા
          </p>
          <p className="mt-3 text-[#F0D788] text-base md:text-lg tracking-wide">
            Your trust · Our service · Your success
          </p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {QUOTES.map((q, i) => (
            <Reveal key={q.en} delay={i * 100}>
              <div
                data-testid={`brand-quote-${i + 1}`}
                className="h-full rounded-2xl p-6 border border-[#D4AF37]/35 bg-white/[0.04] backdrop-blur-sm hover:border-[#D4AF37]/70 transition-all"
              >
                <p className="font-script italic text-xl md:text-2xl text-[#F0D788] leading-snug">
                  {q.gu}
                </p>
                <p className="mt-3 text-white/75 text-sm">{q.en}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
